<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent max-width="500px" transition="dialog-transition" >
      <template v-slot:activator="{on}">
        <v-btn v-on="on" small rounded color="error" dark :loading="loading">Reabrir <v-icon right>mdi-undo</v-icon> </v-btn>
      </template>
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Reabrindo</div>
        </v-card-title>
        <v-card-text>
          <v-form ref='actionPlanCommentForm' lazy-validation>
            <v-textarea :rules="required" v-model="comment.body" rows='4' prepend-icon="mdi-chat" label="Qual o motivo de reabertura?" color="secondary"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="resetComment()" text color="error">Cancelar</v-btn>
          <v-btn @click="submit()" text color="secondary">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading  v-if="loading" :loadingText="'Salvando'"></dialog-loading>
  </div>
</template>


<script>

import Vue from "vue";
import { mapActions, mapState, mapMutations } from "vuex";
import validations from "@/mixins/validations";

export default {
  name: 'ButtonReopen',
  mixins: [validations],
  data() {
    return {
      loading: false,
      dialog: false,
      comment: {
        body: null,
        user_id: null,
      }
    };
  },
  methods: {
    resetComment(){
      this.comment.body = null
      this.comment.user_id = null
      this.dialog = false
    },
    async submit() {
      if (this.$refs.actionPlanCommentForm.validate()){
        this.$swal({
          title: `Atualizar?`,
          text: "O plano de ação será reaberto.",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: this.$vuetify.theme.themes['light'].primary,
          cancelButtonText: "Não"
        }).then(r=>{
          if (r.isConfirmed) {
            this.loading = true;
            this.comment.user_id = this.profile.id
            let obj = {
              status: "opened", 
              comments_attributes: [
                // {user_id: this.profile.id, body: 'Plano de ação reaberto!'},
                {
                  ...this.comment,
                  body: `Plano de ação reaberto!\n\n${this.comment.body}`,
                }
              ]
            }
            Vue.axios.put(`/action_plans/${this.$route.params.id}`, {
              action_plan: { ...obj }
            }).then(response => response.data).then(data => {
              this.loading = false;
              this.setOneActionPlan(data)
              this.addNotification({type: 'success', msg: 'Atualizado com sucesso!'})
              // this.getOneActionPlan(this.$route.params.id);
            }).catch(error => {
              console.log(error);
              this.loading = false;
            });
          }
        }).catch(err => {
          console.log(err)
        })
      }

    },
    ...mapActions({
      addNotification: "Notification/add",
      // getOneActionPlan: "ActionPlan/getOneActionPlan",
      // getAllMyActionPlans: "ActionPlan/getAllMyActionPlans"
    }),
    ...mapMutations({
      setOneActionPlan: "ActionPlan/setOneActionPlan"
    })
  },
  computed: {
    name() {
      return this.data 
    },
    ...mapState({
      profile: state=> state.User.oneUser
    })
  },
};
</script>